const MULTI_ENVIRONMENT_KEY_DEFINITIONS = Object.freeze([
    {
        id: 'server',
        field: 'server_key',
        label: 'Server Key',
    },
    {
        id: 'mobile',
        field: 'mobile_key',
        label: 'Mobile Key',
    },
    {
        id: 'client',
        field: 'client_key',
        label: 'Client Key',
    },
])

const normalizeEnvironmentKeyValue = (value) => {
    if (typeof value !== 'string') {
        return null
    }

    const trimmed = value.trim()

    return trimmed === '' ? null : trimmed
}

export function getMultiEnvironmentKeyEntries(environment = {}) {
    return MULTI_ENVIRONMENT_KEY_DEFINITIONS.map((definition) => {
        const value = normalizeEnvironmentKeyValue(
            environment[definition.field]
        )

        return {
            ...definition,
            value,
            available: value !== null,
        }
    })
}

export function getEnvironmentKeyCopySuccessMessage(label) {
    return `${label} copied to clipboard.`
}

export function getEnvironmentKeyCopyErrorMessage(label) {
    return `Failed to copy ${label.toLowerCase()} to clipboard.`
}
